<div class="lock-ovh">
  <div class="cooking-story-header" [ngClass]="{ shadow: shadowNav }">
    <img
      class="icon icon-shadow"
      (click)="goBak()"
      src="assets/cookingbook/angle-white.svg"
      alt=""
    />
    <p class="title">
      {{ title }}
    </p>
  </div>
  <div class="cooking-story-body" (scroll)="scrolling($event)" #scroolEl>
    <div class="masonry">
      <div>
        <div
          *ngFor="let pos of leftCoulumn; let i = index"
          class="posts recipe-shadow"
          [ngClass]="{ bigger: i % 2 == 0, smaller: i % 2 != 0 }"
          (click)="openRecipe(pos._id)"
        >
          <div
            [ngStyle]="{
              'background-image': 'url(' + pos?.image + ')',
              'background-position': 'center center',
              'background-repeat': 'no-repeat'
            }"
            class="recipe-box"
          >
            <div class="label">
              <P class="pl-5">
                {{ pos?.likes }}
              </P>
              <img src="assets/cookingbook/heart.svg" alt="" />
            </div>
            <img
              class="play-icon"
              *ngIf="pos?.video"
              src="assets/cookingbook/play.svg"
              alt=""
            />
          </div>
          <p class="recipe-name">
            {{ pos?.name }}
          </p>
        </div>
      </div>
      <div class="space"></div>
      <div>
        <div
          *ngFor="let pos of rightColumn; let i = index"
          class="posts recipe-shadow"
          [ngClass]="{ bigger: i % 2 != 0, smaller: i % 2 == 0 }"
          (click)="openRecipe(pos._id)"
        >
          <div
            [ngStyle]="{
              'background-image': 'url(' + pos?.image + ')',
              'background-position': 'center center',
              'background-repeat': 'no-repeat'
            }"
            class="recipe-box"
          >
            <div class="label">
              <P class="pl-5">
                {{ pos?.likes }}
              </P>
              <img src="assets/cookingbook/heart.svg" alt="" />
            </div>
            <img
              class="play-icon"
              *ngIf="pos?.video"
              src="assets/cookingbook/play.svg"
              alt=""
            />
          </div>
          <p class="recipe-name">
            {{ pos?.name }}
          </p>
        </div>
      </div>
    </div>
    <div *ngIf="!ready" class="cooking-story-loading">
      <div class="loading-holder" *ngFor="let i of garr(10)">
        <ngx-skeleton-loader
          animation="pulse"
          class="text-loader2"
        ></ngx-skeleton-loader>
        <ngx-skeleton-loader
          animation="pulse"
          [theme]="{
            margin: 'auto',
            height: '148px',
            background: 'rgb(216, 216, 216)',
            'border-radius': '24px'
          }"
        ></ngx-skeleton-loader>
      </div>
    </div>
  </div>
  <div [ngClass]="{ show: sending && ready }" class="loading">
    <svg class="splash-spinner" viewBox="0 0 50 50">
      <circle
        class="path"
        cx="25"
        cy="25"
        r="20"
        fill="none"
        stroke-width="5"
      ></circle>
    </svg>
  </div>
</div>
